var libs = {
    noCacheUrl:function($src){
        var $date = new Date();
        var $random = Math.random();
        var $i = $date.toString().replace(/\s/g, '')+''+$random;
        var $url = new URL($src);
        if(!$url.searchParams.has('n-o-c-a-c-h-e')){
            $url.searchParams.append('n-o-c-a-c-h-e', $i)
        }else{
            $url.searchParams.set('n-o-c-a-c-h-e', $i);
        }
        return $url.toString();
    },
    refreshBoxFrom:function($element, $data, cback){
        if($($element).length > 0) {
            $($element).each(function ($v, $i) {
                var $that = $(this);
                if (!$that.data('url') || $that.parents('.box').length <= 0) {
                    return false;
                }
                $.ajax({
                    url: $that.data('url'),
                    method: 'POST',
                    cache: false,
                    data: $data ? $data : null,
                    dataType: "html",
                    success: function ($data) {
                        libs.expire($data);
                        $that.parents('.box').first().html($data).promise().done(function () {
                          if (cback != undefined) {
                              cback($(this));
                          }
                        });
                    }
                });
            });
        }else{
            if (cback != undefined) {
                cback($(this));
            }
        }
    },
    renderImage:function($input, $target){
        if ($input.files && $input.files[0]) {
            var $reader = new FileReader();
            $reader.onload = function(e) {
                $($target).attr('src', e.target.result);
            };
            $reader.readAsDataURL($input.files[0]);
        }
    },
    imageUrlToBlob:function($url, cback, $outFormat){
        var $img = new Image();
        $img.crossOrigin = 'Anonymous';
        $img.onload = function(){
            var $canvas = document.createElement('CANVAS'),
                $ctx = $canvas.getContext('2d'), $dataURL;
            $canvas.height = $img.height;
            $canvas.width = $img.width;
            $ctx.drawImage($img, 0, 0);
            $dataURL = $canvas.toDataURL($outFormat);
            cback($dataURL);
            $canvas = null;
        };
        $img.src = $url;
    },
    renderFile:function($blobFile, $target){
        var $reader = new FileReader();
        $reader.onload = function(e) {
            $($target).attr('src', e.target.result);
        };
        $reader.readAsDataURL($blobFile);
    },
    getImageWH:function($urlFile, cback){
        var $img = new Image();
        $img.onload = function() {
            cback(this.width, this.height);
        };
        $img.src = $urlFile;
    },
    b64toBlob:function($imageBase64) {
        var $byteString = atob($imageBase64.split(',')[1]);
        var $ab = new ArrayBuffer($byteString.length);
        var $ia = new Uint8Array($ab);
        for (var $i = 0; $i < $byteString.length; $i++) {
            $ia[$i] = $byteString.charCodeAt($i);
        }
        var $type = $imageBase64.split(',')[0];
        $type = $type.split(':')[1];
        $type = $type.split(';')[0];
        return new Blob([$ab], { type: $type});
    },
    toEntities:function ($text){return $("<div/>").html($text).text();},
    base64 : {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) {
            var t = "";
            var n, r, i, s, o, u, a;
            var f = 0;
            e = Base64._utf8_encode(e);
            while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) {
                    u = a = 64
                } else if (isNaN(i)) {
                    a = 64
                }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
            }
            return t
        }, decode: function (e) {
            var t = "";
            var n, r, i;
            var s, o, u, a;
            var f = 0;
            e = e.replace(/[^A-Za-z0-9+/=]/g, "");
            while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) {
                    t = t + String.fromCharCode(r)
                }
                if (a != 64) {
                    t = t + String.fromCharCode(i)
                }
            }
            t = Base64._utf8_decode(t);
            return t
        }, _utf8_encode: function (e) {
            e = e.replace(/rn/g, "n");
            var t = "";
            for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r)
                } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                }
            }
            return t
        }, _utf8_decode: function (e) {
            var t = "";
            var n = 0;
            var r = c1 = c2 = 0;
            while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3
                }
            }
            return t
        }
    },
    getUrl : $(location).attr("href"),
    getObjForm:function($form){
        var $data = {};
        var $serialize = $($form).serializeArray();
        for (var $attr in $serialize) {
            if($data[$serialize[$attr].name] != undefined){
                if(Array.isArray($data[$serialize[$attr].name]) !== true){
                    var $first = $data[$serialize[$attr].name];
                    $data[$serialize[$attr].name] = [];
                    $data[$serialize[$attr].name].push($first);
                }
                $data[$serialize[$attr].name].push($serialize[$attr].value);
            }else {
                $data[$serialize[$attr].name] = $serialize[$attr].value;
            }
        }
        return $data;
    },
    ajaxSetup : function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },
    isJson : function($data) {
        try {
            JSON.parse($data);
        } catch (e) {
            return false;
        }
        return true;
    },
    expire:function($data){
        try{
            if(libs.isJson($data)){
                $data = JSON.parse($data);
            }
            if($data.status == 'success'){
                if($data.data && $data.data.msg && $data.data.msg != ''){
                    toastr.info($data.data.msg);
                }
            }
            if($data.status == 'error'){
                if($data.data && $data.data.msg && $data.data.msg != ''){
                    toastr.error($data.data.msg);
                }
            }
            if($data.status == 'redirect'){
                if($data.data && $data.data.msg && $data.data.msg != ''){
                    toastr.error($data.data.msg);
                }
                window.location = $data.redirect;
            }
            if($data.status == 'expire'){
                window.location = '/logout';
            }
        }catch (error){

        }
    },
    render : function ($url, $module, $submodule, $params, $method) {
        var $chtml = '' +
            '<div class="container-fluid">' +
            '    <div class="animated fadeIn">' +
            '        <div class="row margin-section">' +
            '            <div class="col-sm-4 col-md-4 col-lg-4 offset-sm-4 offset-md-4 offset-lg-4 my-3 text-center loader-container">' +
            '                <img src="/bimg/NursesLounge/loader-lounge.gif" class="rounded img-fluid clear-img loader">' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';
            libs.checkImageLoad($($chtml).find('img'), function(){
                $("#content").html($chtml).promise().done(function(){
                    if(!$method){$method = "GET";}
                    $.ajax({
                        url: $url,
                        method: $method,
                        cache:false,
                        dataType: "html",
                        data: $params,
                        success: function ($data) {
                            libs.expire($data);
                            $("#content").hide();
                            $("#content").html($data).promise().done(function () {
                                $submodule = $submodule.replace(/\//g,'_');
                                eval($module + '.' + $submodule +'($params)');
                            });
                            if($($data).find('img').length > 0){
                                libs.checkImageLoad($($data).find('img'), function(){
                                    $("#content").fadeIn();
                                });
                            }else{
                                $("#content").fadeIn();
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if($("#content").html() == ''){
                                libs.render($url, $module, $submodule, $params, $method);
                            }
                        }
                    });
                });
            });
    },
    subrender : function ($url, $module, $submodule, $params, $method) {
        var $chtml = '' +
            '<div class="container-fluid">' +
            '    <div class="animated fadeIn">' +
            '        <div class="row margin-section">' +
            '            <div class="col-sm-4 col-md-4 col-lg-4 offset-sm-4 offset-md-4 offset-lg-4 my-3 text-center loader-container">' +
            '                <img src="/bimg/NursesLounge/loader-lounge.gif" class="rounded img-fluid clear-img loader">' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';
            libs.checkImageLoad($($chtml).find('img'), function(){
                $("#subcontent").html($chtml).promise().done(function(){
                    if(!$method){$method = "GET";}
                    $.ajax({
                        url: $url,
                        method: $method,
                        cache:false,
                        dataType: "html",
                        data: $params,
                        success: function ($data) {
                            libs.expire($data);
                            $("#subcontent").hide();
                            $("#subcontent").html($data).promise().done(function () {
                                $("#subcontent").fadeIn();
                                $submodule = $submodule.replace(/\//g,'_');
                                eval($module + '.' + $submodule+'($params)');
                            });
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if($("#subcontent").html() == ''){
                                libs.render($url, $module, $submodule, $params, $method);
                            }
                        }
                    });
                });
            });
    },
    memorySave:function($name, $obj){
        if(window.$memory == undefined){
            window.$memory = {};
        }
        window.$memory[$name] = $obj;
    },
    memoryGet:function($name){
        if(window.$memory != undefined && window.$memory[$name] != undefined){
            return window.$memory[$name];
        }else{
            return false;
        }
    },
    resetForm:function($form){
        $($form)[0].reset();
        $($form).find("input[type=hidden]").val("");
    },
    loading:function(){
        $("#content").html('' +
            '<div class="container-fluid">' +
            '    <div class="animated fadeIn my-2">' +
            '        <img src="/bimg/Login/loader-lounge.gif?" class="img-fluid">' +
            '    </div>' +
            '</div>');
    },
    replaceBreaklines:function($content){
        var $regex = new RegExp('<br>', 'g');
        return $content.replace($regex, '\r\n');
    },
    replacePerBreaklines:function($content){
        var $regex = new RegExp('(?:\\r\\n|\\r|\\n)', 'g');
        return $content.replace($regex, '<br>');
    },
    convertUrlToLink:function($content){
        var $regex = new RegExp('((?!(href))\\b(https?|):\\/\\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])', 'gim');
        return  $content.replace($regex, "<a target='_blank' href='$1'>$1</a>");
    },
    checkImageLoad:function($imageContainer, cback){
        var $total = $($imageContainer).length;
        var $checked = 0;
        $($imageContainer).each(function(){
            var $img = new Image();
            $img.onload = function() {
                $checked++;
                if($total == $checked){
                    cback();
                }
            };
            $img.src = $(this).attr('src');
        });
        if($total == $checked){
            cback();
        }
    },
    renderPDF:function($input, $target, $options){
        if ($input.files && $input.files[0]) {
            var $reader = new FileReader();
            $reader.onload = function(e) {
                PDFObject.embed(e.target.result, $target, $options);
            };
            $reader.readAsDataURL($input.files[0]);
        }
    },
    pdfToImage:function($file, $target, cback){
        pdfjsLib.disableWorker = true;
        pdfjsLib.getDocument($file).then(function($pdf) {
            $pdf.getPage(1).then(function($page) {
                var $scale = 1.5;
                var $viewport = $page.getViewport({ scale: $scale, });
                var $canvas = $('<canvas></canvas>')[0];
                var $context = $canvas.getContext('2d');
                $canvas.height = $viewport.height;
                $canvas.width = $viewport.width;
                var $renderContext = {
                    canvasContext: $context,
                    viewport: $viewport
                };
                $page.render($renderContext).promise.then(function(){
                    var $urlBase64 = $canvas.toDataURL('image/jpeg');
                    if($target != null){
                        $target.attr('src', $urlBase64);
                    }
                    if(cback != undefined){
                        cback($urlBase64);
                    }
                });
            });
        });
    },
    blobToB64: function ($file, cback) {
        var $reader = new FileReader();
        $reader.onload = function(e) {
            cback(e.target.result);
        };
        $reader.readAsDataURL($file);
    },
    hex2rgb: function($hex){
        var $result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec($hex);
        return 'rgb('+parseInt($result[1], 16)+', '+parseInt($result[2], 16)+', '+parseInt($result[3], 16)+')';
    },
    rgb2hex:function($color){
        var $rgb = $color.replace(/\s/g,'').match(/^rgba?\((\d+),(\d+),(\d+)/i);
        return ($rgb && $rgb.length === 4) ? "#" +
            ("0" + parseInt($rgb[1],10).toString(16)).slice(-2) +
            ("0" + parseInt($rgb[2],10).toString(16)).slice(-2) +
            ("0" + parseInt($rgb[3],10).toString(16)).slice(-2) : $color;
    },
    cmToPixel:function($cm) {
        return $cm * 37.7952755905511;
    },
    isEmptyReturnNull:function($obj){
        if($obj){
            return $obj;
        }else{
            return null;
        }
    },
    extendReplace:function($target, $src){
        $target = $target || {};
        for (var $prop in $src) {
            if (typeof $src[$prop] === 'object') {
                $target[$prop] = $.extend({},$target[$prop], $src[$prop]);
            }
            if (Array.isArray($src[$prop])) {
                $target[$prop] = Object.values($src[$prop]);
            }
            if(typeof $src[$prop] !== 'object' && !Array.isArray($src[$prop])) {
                $target[$prop] = $src[$prop];
            }
            if($src[$prop] == null){
                delete $target[$prop];
            }
        }
        return $target;
    },
    memoryUpdateObj:function($name, $obj){
        libs.memorySave($name, $.extend({},libs.memoryGet($name), $obj));
    },
    arrGroupByObj:function($array, $key) {
        return $array.reduce(function($prev, $new) {
            var $value = $new[$key];
            $prev[$value] = ($prev[$value] || []).concat($new);
            return $prev;
        }, {});
    },
    arrSumObj:function($arr, $key) {
        var $newArr = {};
        return $arr.reduce(function($prev, $new){
            var $prevNum =  $prev[$key] || 0;
            var $newNum  =  $new[$key] || 0;
            var $sum = parseFloat($newNum) + parseFloat($prevNum);
            $newArr[$key]=$sum;
            return $newArr;
        }, []);
    },
    arrSortObj:function($arr, $key, $ascDesc){
        $arr = $arr.sort(function($k1, $k2) {
            return $k1[$key] - $k2[$key];
        });
        return $ascDesc == undefined || $ascDesc == 'asc' ? $arr : $arr.reverse();
    },
    pluck:function($arr, $value){
        return $.map($arr, function($v){
            return $v[$value];
        });
    },
    snakeToCamel:function($i){
        return $i.replace(/(\_\w)/g, function (m) {
            return m[1].toUpperCase();
        });
    },
    getUniqueId:function(){
        var $dt = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function($c) {
            var $r = ($dt + Math.random()*16)%16 | 0;
            $dt = Math.floor($dt/16);
            return ($c=='x' ? $r :($r&0x3|0x8)).toString(16);
        });
    },
    isMobile:function(){
        return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test((navigator.userAgent||navigator.vendor||window.opera))||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4)));
    },
    isAndroid:function(){
        var $ua = navigator.userAgent.toLowerCase();
        return $ua.indexOf("android") > -1;
        ///ios|iphone|ipod|ipad|android/i.test(navigator.userAgent)
    },
    refreshTooltips:function(){
        var $clean = null;
        if(!libs.isMobile()){
            $('div[role="tooltip"]').remove();
            $("body .with-tooltip").not('.with-tooltip-month-event').each(function(){
                var $that = $(this);
                var $permanent = $that.data('permanent');
                if($permanent){
                    $that.tooltip({
                        trigger: 'hover'
                    });
                }else{
                    $that.tooltip({
                        delay: {
                            show: 500,
                            hide: 0
                        },
                        trigger: 'hover'
                    }).on('shown.bs.tooltip', function() {
                        try{
                            clearTimeout($clean);
                        }catch ($e) {

                        }
                        $clean = setTimeout(function(){
                            $(this).tooltip('hide');
                            $('div[role="tooltip"]').remove();
                        }, 3000);
                    });
                }
            });
        }
    },
    pad:function($pad, $str, $pos){
        if (typeof $str === 'undefined')
            return $pad;
        if($pos == 'l'){
            return ($pad + $str).slice(-$pad.length);
        }else{
            return ($str + $pad).substring(0,$pad.length);
        }
    },
    ucfirst($str){
        return $str.charAt(0).toUpperCase() + $str.slice(1);
    },
    globalUrl:function(){
        $("#topNav .main-nav > li > a").removeClass('active');
        $("#topNav .main-nav > li > a").each(function(){
            var $that = $(this);
            var $pathname = window.location.pathname;
            if($pathname.includes('public')){
                $pathname = $pathname.split('/');
                $pathname = $pathname.filter(function($v, $i){
                    return $v != 'public';
                });
                $pathname = $pathname.join('/');
            }
            $pathname = $pathname.split('/');
            $pathname = $pathname.reverse();
            var $href = $that.attr('href').split('/');
            if($href.includes('public')){
                $href = $href.filter(function($v, $i){
                    return $v != 'public';
                });
            }
            $href = $href.join('/');
            if(
                $pathname.includes('continuingEducation') && $href == '/continuingEducation'
            ){
                $that.addClass('active');
            }
            if(
                $pathname.includes('articles') && $href == '/articles' ||
                $pathname.includes('article') && $href == '/articles'
            ){
                $that.addClass('active');
            }
            if(
                $pathname.includes('jobs') && $href == '/jobs' ||
                $pathname.includes('job') && $href == '/jobs'
            ){
                $that.addClass('active');
            }
            if(
                $pathname.includes('degrees') && $href == '/degrees' ||
                $pathname.includes('degree') && $href == '/degrees'
            ){
                $that.addClass('active');
            }
            if(
                $pathname.includes('lounges') && $href == '/lounges' ||
                $pathname.includes('lounge') && $href == '/lounges'
            ){
                if(
                    !$pathname.includes('degrees') &&
                    !$pathname.includes('degree') &&
                    !$pathname.includes('jobs') &&
                    !$pathname.includes('job')
                ){
                    $that.addClass('active');
                }
            }
            if(
                $pathname.includes('myDashboard') && $href == '/myDashboard'
            ){
                $that.addClass('active');
            }
            if(
                $pathname.includes('thoughtLeaders') && $href == '/thoughtLeaders'
            ){
                $that.addClass('active');
            }
        });
    },
};

var dataTable = {
    setup:function(){
        $.fn.dataTable.ext.errMode = function ( settings, helpPage, message ) {
        };
    },
    init:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete, ajaxDataFilter){
        var $table = $($element).DataTable({
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "order": [[0,"desc"]],
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "fixedColumns":   {
                "leftColumns": 1
            },
            //"autoWidth": false,
            //"responsive": true,
            "bDestroy": true,
            "drawCallback": function () {
                if(drawCallback != undefined){
                    drawCallback($table);
                }
            },
            "fnRowCallback": function($nRow){
                if(fnRowCallback != undefined){
                    fnRowCallback($nRow);
                }
            },
            "initComplete": function () {
                if(initComplete != undefined){
                    initComplete($table);
                }
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":$data,
                "dataFilter": function($response) {
                    if(ajaxDataFilter != undefined){
                        ajaxDataFilter(JSON.parse($response));
                    }
                    return $response;
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    reload:function($element){
        $.fn.dataTableExt.oApi.fnReloadAjax = function ( oSettings, sNewSource, fnCallback, bStandingRedraw ){
            if(jQuery.fn.dataTable.versionCheck ){
                var api = new jQuery.fn.dataTable.Api( oSettings );
                if(sNewSource){
                    api.ajax.url(sNewSource).load(fnCallback,!bStandingRedraw);
                }
                else{
                    api.ajax.reload(fnCallback,!bStandingRedraw);
                }
                return;
            }
            if(sNewSource !== undefined && sNewSource !== null){
                oSettings.sAjaxSource = sNewSource;
            }
            if(oSettings.oFeatures.bServerSide){
                this.fnDraw();
                return;
            }
            this.oApi._fnProcessingDisplay( oSettings, true );
            var that = this;
            var iStart = oSettings._iDisplayStart;
            var aData = [];
            this.oApi._fnServerParams(oSettings,aData);
            oSettings.fnServerData.call( oSettings.oInstance, oSettings.sAjaxSource, aData, function(json) {
                that.oApi._fnClearTable( oSettings );
                var aData = (oSettings.sAjaxDataProp !== "") ? that.oApi._fnGetObjectDataFn( oSettings.sAjaxDataProp )( json ) : json;
                for (var i=0;i<aData.length;i++){
                    that.oApi._fnAddData( oSettings, aData[i] );
                }
                oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
                that.fnDraw();
                if(bStandingRedraw === true){
                    oSettings._iDisplayStart = iStart;
                    that.oApi._fnCalculateEnd(oSettings);
                    that.fnDraw(false);
                }
                that.oApi._fnProcessingDisplay(oSettings,false);
                if(typeof fnCallback == 'function' && fnCallback !== null){
                    fnCallback( oSettings );
                }
            }, oSettings );
        };
        $($element).dataTable().fnReloadAjax();
    }
};
$(document).ready(function(){
    libs.ajaxSetup();
    libs.refreshTooltips();
    libs.globalUrl();
    dataTable.setup();
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    Webcam.set({
        image_format: 'jpeg',
        jpeg_quality: 100,
        swfURL: '/js/NursesLounge/webcam.swf',
    });
    $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open');
    });
});
